import { render, staticRenderFns } from "./VisitsFrequency.vue?vue&type=template&id=28d53842"
import script from "./VisitsFrequency.vue?vue&type=script&lang=js"
export * from "./VisitsFrequency.vue?vue&type=script&lang=js"
import style0 from "./VisitsFrequency.vue?vue&type=style&index=0&id=28d53842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports